import request from '@/utils/request'

/**
 * 员工管理
 */

// 获取员工列表
export const getGoonsList = (params: any) => {
  return request({
    url: '/admin/goons/page',
    method: 'get',
    params
  })
}

// 新增员工
export const addGoons = (params: any) => {
  return request({
    url: '/admin/goons',
    method: 'post',
    data: { ...params }
  })
}

// 修改员工信息
export const editGoons = (params: any) => {
  // 确保ID存在
  if (!params.id && params.id !== 0) {
    console.error('编辑员工时缺少ID:', params);
  }
  
  return request({
    url: '/admin/goons',
    method: 'put',
    data: { ...params }
  })
}

// 删除员工
export const deleteGoons = (ids: string) => {
  return request({
    url: `/admin/goons/${ids}`,
    method: 'delete'
  })
}

// 根据ID查询员工信息
export const queryGoonsById = (id: string | (string | null)[]) => {
  return request({
    url: `/admin/goons/${id}`,
    method: 'get'
  })
}

// 修改员工状态（是否工作中）
export const updateGoonsStatus = (params: any) => {
  return request({
    url: `/admin/goons/working/${params.id}/${params.status}`,
    method: 'put'
  })
}

/**
 * 员工入驻申请管理
 */

// 获取员工入驻申请列表
export const getGoonsApplyList = (params: any) => {
  return request({
    url: '/admin/goonsApply/page',
    method: 'get',
    params
  })
}

// 通过员工入驻申请
export const approveGoonsApply = (id: string) => {
  return request({
    url: `/admin/goonsApply/review/${id}/1`,
    method: 'put'
  })
}

// 拒绝员工入驻申请
export const rejectGoonsApply = (id: string) => {
  return request({
    url: `/admin/goonsApply/review/${id}/2`,
    method: 'put'
  })
}

// 获取员工申请详情
export const getGoonsApplyDetail = (id: string) => {
  return request({
    url: `/admin/goonsApply/${id}`,
    method: 'get'
  })
}

// 删除员工申请
export const deleteGoonsApply = (id: string) => {
  return request({
    url: `/admin/goonsApply/${id}`,
    method: 'delete'
  })
}

// 用户提交员工申请
export const submitGoonsApply = (params: any) => {
  return request({
    url: '/user/goonsApply/submit',
    method: 'post',
    data: { ...params }
  })
}